<template>
  <ButtonVue label="Añadir usuario" icon="fa-solid fa-square-plus fa-spin"
    style="--fa-animation-iteration-count: 1; --fa-animation-duration: 2.5s;" class="mt-2" text @click="openModal" />

  <DialogVue header="Creación del titular" :visible="displayModal" :modal="true" :closable="false"
    class="flex align-items-center justify-content-center surface-0 shadow-8" contentClass="p-fluid"
    :contentStyle="{ overflowX: 'hidden' }" :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '85vw' }">

    <div class="grid m-0 mb-6">

      <!-- Divider -->
      <div class="col-12 mb-5">
        <DividerVue align="center">
          <span class="p-tag coloraux1 mx-2 px-2">
            <i class="fa-solid fa-people-group pr-2"></i>
            Datos del nuevo usuarios
          </span>
        </DividerVue>
      </div>
      <!-- Divider -->
      <div class="col-12 md:col-12">
        <label>Tipo de usuario </label>
        <DropdownVue filter v-model="typeUser" class="w-100" :options="typeUserOptions" optionLabel="label"
          optionValue="value" placeholder="Selecciona cargo" @change="getDependencias" />
        <InlineMessageVue v-model:hidden="validaTypeUser" class="msgValidaciones">
          <i class="fa-solid fa-circle-exclamation fa-bounce" style="--fa-animation-duration: 1.5s;"></i>
          <span class="px-2">Por favor Ingresa el tipo de usuario</span>
        </InlineMessageVue>
      </div>

      <div v-if="typeUser == 5" class="col-12 md:col-12">
        <label>Dependencia </label>
        <DropdownVue :loading="loadingDep" filter v-model="dep_id" class="w-100" :options="dependencias"
          optionLabel="label" optionValue="value" placeholder="Selecciona cargo" @change="getOficinas" />

        <InlineMessageVue v-model:hidden="validaDep" class="msgValidaciones">
          <i class="fa-solid fa-circle-exclamation fa-bounce" style="--fa-animation-duration: 1.5s;"></i>
          <span class="px-2">Por favor Ingresa la dependencia</span>
        </InlineMessageVue>
      </div>

      <div v-if="typeUser == 5" class="col-12 md:col-12">
        <label>Oficina(s) </label>
        <MultiSelectVue :loading="loadingOficina" filter v-model="oficinas_id" display="chip"
          :virtualScrollerOptions="{ itemSize: 44 }" scrollHeight="250px" :options="oficinas" optionLabel="label"
          optionValue="value" placeholder="Selecciona oficina" />

        <InlineMessageVue v-model:hidden="validaOficina" class="msgValidaciones">
          <i class="fa-solid fa-circle-exclamation fa-bounce" style="--fa-animation-duration: 1.5s;"></i>
          <span class="px-2">Por favor Ingresa la oficina</span>
        </InlineMessageVue>
      </div>

      <!-- Form del Nombre -->
      <div class="col-12 sm:col-12 md:col-12 lg:col-4 xl:col-4 p-1 flex align-items-center justify-content-center">
        <div class="p-inputgroup mx-1">
          <ChipVue label="Nombre:" icon="fa-solid fa-person-rays" class="chipsForm" />
          <p class="p-2">{{ usuarioNombreRef }}</p>
        </div>
      </div>


      <!-- Form del Nombre -->

      <!-- Form del A. Paterno -->
      <div class="col-12 sm:col-12 md:col-12 lg:col-4 xl:col-4 p-1 flex align-items-center justify-content-center">
        <div class="p-inputgroup mx-1">
          <ChipVue label="Apellido paterno:" icon="fa-solid fa-person" class="chipsForm" />
          <p class="p-2">{{ usuarioAPaternoRef }}</p>
        </div>
      </div>
      <!-- Form del A. Paterno -->

      <!-- Form del A. Materno -->
      <div class="col-12 sm:col-12 md:col-12 lg:col-4 xl:col-4 p-1 flex align-items-center justify-content-center">
        <div class="p-inputgroup mx-1">
          <ChipVue label="Apellido materno:" icon="fa-solid fa-person-dress" class="chipsForm" />
          <p class="p-2">{{ usuarioAMaternoRef }}</p>
        </div>
      </div>
      <!-- Form del A. Materno -->

      <!-- Form del CURP -->
      <div class="col-12 sm:col-12 md:col-12 lg:col-6 xl:col-6 p-1 py-5">
        <div class="p-inputgroup mx-1">
          <ChipVue label="CURP:" icon="fa-solid fa-clipboard-user" class="chipsForm" />
          <InputTextV type="text" v-model="usuarioCurpRef" maxlength="18" style="text-transform:uppercase"
            id="stringCurp" v-on:keyup="validarCurpUsuarioForm()" :disabled="disabledCurp" />
        </div>

        <InlineMessageVue v-model:hidden="validaCurp" class="msgValidaciones">
          <i class="fa-solid fa-circle-exclamation fa-bounce" style="--fa-animation-duration: 1.5s;"></i>
          <span class="px-2">Por favor Ingresa el CURP del Usuario</span>
        </InlineMessageVue>

        <InlineMessageVue v-model:hidden="validaCurpInvalida" class="msgValidaciones">
          <i class="fa-solid fa-circle-exclamation fa-bounce" style="--fa-animation-duration: 1.5s;"></i>
          <span class="px-2">La CURP no es Valida</span>
        </InlineMessageVue>
      </div>
      <!-- Form del CURP -->

      <!-- Form del Correo -->
      <div class="col-12 sm:col-12 md:col-12 lg:col-6 xl:col-6 p-1 py-5">
        <div class="p-inputgroup mx-1">
          <ChipVue label="Correo:" icon="fa-solid fa-square-envelope" class="chipsForm" />
          <InputTextV type="text" v-model="usuarioCorreoRef" />
        </div>

        <InlineMessageVue v-model:hidden="validaCorreo" class="msgValidaciones">
          <i class="fa-solid fa-circle-exclamation fa-bounce" style="--fa-animation-duration: 1.5s;"></i>
          <span class="px-2">Por favor Ingresa el correo del usuario valido</span>
        </InlineMessageVue>
      </div>
      <!-- Form del Correo -->

      <div class="col-12 mb-3 fixed-top flex align-items-center justify-content-end">
        <ButtonVue icon="fa-solid fa-xmark" @click="closeModal"
          class="p-button-rounded p-button-text p-button-secondary" />
      </div>

      <!-- Boton para crear el Usuario -->
      <div class="col-12 mt-3 fixed-bottom flex align-items-center justify-content-center">
        <ButtonVue label="Crear usuario" icon="fa-solid fa-square-plus" v-model:disabled="isLoading"
          @click="crearNuevoTitularForm" class="botonGobColorVB scalein animation-duration-1000" />
      </div>
      <!-- Boton para crear el Usuario -->

    </div>

  </DialogVue>
</template>

<script>
import { ref } from 'vue';
// import useDialogCrearUsuarios from '../composables/useDialogCrearUsuarios';
import useDialogCrearTitulares from '../composables/useDialogCrearTitulares';
import journalApi from '@/api/laravelApi';

//import store from '@/store'; 


export default {

  setup() {

    const displayModal = ref(false);

    /* Propiedades del Modal */
    const openModal = () => {
      displayModal.value = true;

    };

    //funcion para cerrar modal
    const closeModal = () => {
      limpiarForm();
      displayModal.value = false;
    }

    //Datos para el Form
    const usuarioCurpRef = ref();
    const usuarioCorreoRef = ref();


    const usuarioNombreRef = ref();
    const usuarioAPaternoRef = ref();
    const usuarioAMaternoRef = ref();


    //Validacion
    const validaCurp = ref(true);
    const validaCorreo = ref(true);

    const validaCurpInvalida = ref(true);

    const validaOficina = ref(true);
    const oficinas_id = ref([]);
    const oficinas = ref([]);
    const loadingOficina = ref(false);

    const typeUser = ref();
    const validaTypeUser = ref(true);
    const typeUserOptions = ref([
      { label: 'Titular', value: 1 },
      { label: 'Oficialia', value: 5 },
      { label: 'Super Administrador', value: 3 },
    ]);

    const {
      crearNuevoTitular,
      validarCurpTitular,
    } = useDialogCrearTitulares();

    const limpiarForm = () => {
      validaCurp.value = true;
      validaCorreo.value = true;

      usuarioCurpRef.value = undefined;
      usuarioCorreoRef.value = undefined;
      usuarioNombreRef.value = "";
      usuarioAPaternoRef.value = "";
      usuarioAMaternoRef.value = "";
      typeUser.value = null;
      oficinas_id.value = null;
      oficinas.value = [];
      loadingOficina.value = false;
      validaOficina.value = true;

    }

    const validarForm = () => {
      const regexEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;


      if (usuarioCurpRef.value === undefined || usuarioCurpRef.value === "") {
        validaCurp.value = false;
      } else {
        validaCurp.value = true;
      }

      if (typeUser.value === undefined || typeUser.value === null) {
        validaTypeUser.value = false;
      } else {
        validaTypeUser.value = true;
      }

      if (usuarioCorreoRef.value === undefined || usuarioCorreoRef.value === "") {
        validaCorreo.value = false;
      } else {
        let valido = usuarioCorreoRef?.value?.match(regexEmail)
        if (!valido) {
          validaCorreo.value = false;
        } else {
          validaCorreo.value = true;
        }
      }

      if (typeUser.value == 5) {
        if (dep_id.value === undefined || dep_id.value === null) {
          validaDep.value = false;
        } else {
          validaDep.value = true;
        }
      }

      if (typeUser.value == undefined || typeUser.value == null) {
        validaTypeUser.value = false;
      }

      if (typeUser.value == 5) {
        if (oficinas_id.value.length === 0) {
          validaOficina.value = false;
        } else {
          validaOficina.value = true;
        }
      }

    }

    const isLoading = ref(false);//Variable para bloquear el submit

    const liberarBoton = () => {
      isLoading.value = false;
    }

    const bloquearBoton = () => {
      isLoading.value = true;
    }

    let disabledCurp = ref(false);
    const validarCurpUsuarioForm = async () => {

      if (usuarioCurpRef.value.length == 18) {
        disabledCurp.value = true;

        let formData = new FormData();
        formData.append("curp", usuarioCurpRef.value.toUpperCase());
        //await validarCurpUsuario(formData);

        let uValidar = await validarCurpTitular(formData);

        if ((!uValidar?.data?.data?.nombre) || (!uValidar?.data?.data?.apellidoPaterno) || (!uValidar?.data?.data?.apellidoMaterno)) {
          validaCurpInvalida.value = false;
          usuarioNombreRef.value = "Curp Invalida"
          usuarioAPaternoRef.value = "Curp Invalida"
          usuarioAMaternoRef.value = "Curp Invalida"

        } else {
          validaCurpInvalida.value = true;
          usuarioNombreRef.value = uValidar.data.data.nombre;
          usuarioAPaternoRef.value = uValidar.data.data.apellidoPaterno;
          usuarioAMaternoRef.value = uValidar.data.data.apellidoMaterno;
        }

      } else {
        validaCurpInvalida.value = false;
        usuarioNombreRef.value = "..."
        usuarioAPaternoRef.value = "..."
        usuarioAMaternoRef.value = "..."
      }
      disabledCurp.value = false;
    }

    const crearNuevoTitularForm = async () => {
      validarForm();

      if (validaCurp.value === true && validaCorreo.value === true && typeUser.value !== undefined) {
        bloquearBoton();//Validar boton
        let formData = new FormData();
        //formData.append("idOficina", store.state.auth.user.oficina_id);
        //formData.append("curpTitular", store.state.auth.user.curp);
        formData.append("curp", usuarioCurpRef.value);
        formData.append("correo", usuarioCorreoRef.value);
        formData.append("type_user", typeUser.value);
        if (typeUser.value == 5) {
          oficinas_id.value.forEach(element => {
            formData.append("oficinas_id[]", element);
          });
          formData.append("dep_id", dep_id.value);
        }

        await crearNuevoTitular(formData)
        liberarBoton();//Validar boton
        closeModal();
      }
    }

    const dep_id = ref(null);
    const dependencias = ref([]);
    const validaDep = ref(true);
    const loadingDep = ref(false);

    const getDependencias = async () => {
      if (typeUser.value == 5) {
        try {
          loadingDep.value = true;
          const response = await journalApi.get('/directorio/getDependencies');
          dependencias.value = response.data.data.map((item) => {
            return {
              label: item.nombre,
              value: item.id_dep,
            };
          });
          loadingDep.value = false;
        } catch (error) {
          console.log(error);
          loadingDep.value = false;
        }
      }
    }

    const getOficinas = async () => {
      if (typeUser.value == 5) {
        try {
          loadingOficina.value = true;
          const response = await journalApi.get(`/directorio/getOffices/${dep_id.value}`);
          oficinas.value = response.data.data.map((item) => {
            return {
              label: `${item.titular}/${item.oficina}`,
              value: item.id_oficina,
            };
          });
          loadingOficina.value = false;
        } catch (error) {
          console.log(error);
          loadingOficina.value = false;
        }
      }
    }
    return {
      getOficinas,
      oficinas,
      loadingOficina,
      oficinas_id,
      validaOficina,
      displayModal, openModal, closeModal,
      usuarioCurpRef,
      usuarioCorreoRef,
      validaCurp,
      validaCorreo,
      validaCurpInvalida,
      crearNuevoTitularForm,
      validarCurpUsuarioForm,
      validarCurpTitular,
      usuarioNombreRef,
      usuarioAPaternoRef,
      usuarioAMaternoRef,

      isLoading,
      bloquearBoton,
      liberarBoton,
      disabledCurp,
      typeUser,
      typeUserOptions,
      validaTypeUser,
      dep_id,
      dependencias,
      validaDep,
      getDependencias,
      loadingDep,

    }
  }

}
</script>

<style>
.p-dialog-content.p-fluid {
  width: 100%;
}
</style>
<style scoped lang="scss">
.buttonDialog {
  color: gray;
}

.p-button {
  margin: 0.3rem .5rem;
  min-width: 10rem;
}

p {
  margin: 0;
}

::v-deep(.msgValidaciones) {
  .p-inline-message-icon {
    display: none;
  }

  background-color: #fff1d4;
  color:rgb(187, 0, 0);
  font-size: 10px;

}


::v-deep(.p-dialog-content.p-fluid) {
  width: 100%;
}

::v-deep(.p-multiselect) {
  width: 100% !important;
  max-width: 100% !important;
}

::v-deep(.p-multiselect-token-label) {
  max-width: 15vw;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.confirmation-content {
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep(.chipsForm) {
  .p-chip-text {
    font-size: 15px !important;
  }
}

.p-dialog .p-button {
  min-width: 6rem;
}

.gobcolor1 {
  color: #ffff;
  background-color: #4a001f;
}

.gobcolor1:hover {
  color: #ffff;
  background-color: #80245f;
}


/* Clases para las Chips de Asistentes */
::v-deep(.vistobuenochip) {
  .p-chip-text {
    color: white;
    font-size: 13px;
  }
}

.vistobuenochip {
  color: #53bdeb;
  background: #005c4b;
}


::v-deep(.concopiaparachip) {
  .p-chip-text {
    color: white;
    font-size: 13px;
  }
}

.concopiaparachip {
  color: #8e9497;
  background: #005c4b;
}

::v-deep(.firmantechip) {
  .p-chip-text {
    color: white;
    font-size: 13px;
  }
}

::v-deep(.firmantechipMenu) {
  .p-chip-text {
    font-size: 13px;
  }
}

.firmantechip {
  color: yellow;
  background: #005c4b;
}

::v-deep(.enviadoparachip) {
  .p-chip-text {
    color: white;
    font-size: 13px;
  }
}

::v-deep(.enviadoparachipMenu) {
  .p-chip-text {
    font-size: 13px;
  }
}

.enviadoparachip {
  color: rgb(133, 255, 225);
  background: #005c4b;
}

::v-deep(.atencionparachip) {
  .p-chip-text {
    color: white;
    font-size: 13px;
  }
}

.atencionparachip {
  color: rgb(255, 144, 80);
  background: #005c4b;
}

.fondoparachips {
  background: #0b141a;
}

/* Clases para las Chips de Asistentes */

::v-deep(.asistentestable) {
  .p-datatable {
    color: white;
    background: #0b141a;

    .p-column-title {
      color: white;
      background: #0b141a;
    }

  }
}

::v-deep(.botonasistentes) {
  .p-button-label {
    font-size: 12px;
  }
}

.botonasistentes {
  color: white;
  background: #005c4b;
}


.fondoasistentes {
  background: #202c33;
}

.fondoasistentes2 {
  background: #2a3942;
}

.datosOficioEncabezado {
  color: grey;
  font-size: 12px;
}

.datosOficioEncabezadoContenido {
  color: black;
  font-size: 15px;
}

.datosOficioEncabezadoContenido2 {
  font-weight: bold;
  color: black;
  font-size: 15px;
}

.datosOficioEncabezadoContenido3 {
  color: black;
  font-size: 12px;
}

.coloraux1 {
  background: rgb(209, 165, 19);
  font-weight: lighter;
}

.coloraux3 {
  background: rgb(90, 90, 90);
  font-weight: lighter;
}


// Estilos del formulario
::v-deep(.inputGenerales) {
  padding-top: 5px;
  padding-bottom: 5px;
  font-size: 13px;
  font-weight: bold;
}

::v-deep(.dropDownVistas) {
  .p-dropdown-label {
    color: black;
    font-size: 13px;
    font-weight: bold;
  }

  .p-dropdown-trigger {
    display: none;
  }
}

.leyendaDocumento {
  color: black;
  opacity: 0.9;
  font-size: 25px;
}

::v-deep(.inputGeneralesCalendar) {
  .p-inputtext {
    color: black;
    font-size: 13px;
    font-weight: bold;
  }
}

::v-deep(.editorCuerpo) {
  .p-editor-content {
    background: rgba(0, 0, 0, 0.5);
    color: black;
    font-size: 18px;
  }
}

//Responsive



@media only screen and (max-width: 600px) {

  .coloraux1 {
    font-size: 8px;
    background: rgb(19, 111, 209);
    // background: #bec3c9;
    font-weight: lighter;
  }

  .titulosPestanas {
    height: 55px;
    width: 65px;
    transition: ease 1s;
  }

  ::v-deep(.tabsTablas) {
    .p-tabview-nav {
      font-size: 10.5px;
      transition: ease 1s;
    }
  }

  ::v-deep(.dropdownsResp) {
    .p-dropdown {
      font-size: 11px !important;
    }

    .p-dropdown-label {
      font-size: 11px !important;
    }
  }

  ::v-deep(.chipsForm) {
    .p-chip-text {
      font-size: 15px !important;
    }
  }

  ::v-deep(.textoForm) {
    font-size: 11px !important;

    .p-inputtext {
      font-size: 11px !important;
    }
  }

}

@media only screen and (min-width: 600px) {

  .coloraux1 {
    font-size: 8px;
    background: rgb(19, 111, 209);
    // background: #bec3c9;
    font-weight: lighter;
  }

  .titulosPestanas {
    height: 55px;
    width: 65px;
    transition: ease 1s;
  }

  ::v-deep(.tabsTablas) {
    .p-tabview-nav {
      font-size: 11px;
      transition: ease 1s;
    }
  }

}

@media only screen and (min-width: 768px) {

  .coloraux1 {
    font-size: 10px;
    background: rgb(19, 111, 209);
    // background: #bec3c9;
    font-weight: lighter;
  }

  .titulosPestanas {
    height: 55px;
    width: 125px;
    transition: ease 1s;
  }

  ::v-deep(.tabsTablas) {
    .p-tabview-nav {
      font-size: 12px;
      transition: ease 1s;
    }
  }

}

@media only screen and (min-width: 992px) {

  .coloraux1 {
    font-size: 12px;
    background: rgb(19, 111, 209);
    // background: #bec3c9;
    font-weight: lighter;
  }

  .titulosPestanas {
    height: 35px;
    width: 155px;
    transition: ease 1s;
  }

  ::v-deep(.tabsTablas) {
    .p-tabview-nav {
      font-size: 11px;
      transition: ease 1s;
    }
  }

}

@media only screen and (min-width: 1200px) {

  .coloraux1 {
    font-size: 13px;
    background: rgb(19, 111, 209);
    // background: #bec3c9;
    font-weight: lighter;
  }

  .titulosPestanas {
    height: 40px;
    width: 175px;
    transition: ease 1s;
  }

  ::v-deep(.tabsTablas) {
    .p-tabview-nav {
      font-size: 14px;
      transition: ease 1s;
    }
  }

}

@media only screen and (min-width: 1515px) {

  .coloraux1 {
    font-size: 15px;
    background: rgb(19, 111, 209);
    // background: #bec3c9;
    font-weight: lighter;
  }

  .titulosPestanas {
    height: 40px;
    width: 175px;
    transition: ease 1s;
  }

  ::v-deep(.tabsTablas) {
    .p-tabview-nav {
      font-size: 13px;
      transition: ease 1s;
    }
  }

}


/*
@media only screen and (max-width: 600px) {


}

@media only screen and (min-width: 600px) {


}

@media only screen and (min-width: 768px) {


}

@media only screen and (min-width: 992px) {


}

@media only screen and (min-width: 1200px) {


}

@media only screen and (min-width: 1515px) {


}
*/
</style>